module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Acknowledgments"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253049537_Contents#rack",
      "id": "ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("NY UNDERTAKING OF THIS KIND IS ALWAYS COLLABORATIVE")]), _vm._v(" and always reliant upon a whole slew of folks beyond just the editors of the volume. As we have gone through the process of putting the collection together many people have committed time and energy in countless ways, and it is to all those people that we must extend our thanks for their support, encouragement, and pertinent criticism. However, we must accord particular gratitude to both Gary Dunham, director of Indiana University Press, and Lesley Bolton, project manager, for their sterling support and guidance. We also thank Pete Feely of Amnet for his exacting labors on proofing the manuscript. We also want to acknowledge the quality and range of scholarship by the contributors both to "), _c('i', [_vm._v("Killer of Sheep")]), _vm._v(" in particular and, more generally, to Black Film as a whole. We must also thank the artist Jamie Lancaster for her work. Her understanding of the film’s intent is compellingly captured in those images that are on the book’s cover as well as inside the volume. And of course, we are indebted to Charles Burnett, not only for creating such an extraordinary film as "), _c('i', [_vm._v("Killer of Sheep")]), _vm._v(", but for his enduring commitment to the cinematic arts. Finally, as series editors, we would like to extend our heartfelt thanks to Indiana University Press for their continued and unwavering support of the series "), _c('i', [_vm._v("Studies in the Cinema of the Black Diaspora")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Michael T. Martin and David C. Wall"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad971c40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253049537_Acknowledgments.vue
// module id = 78
// module chunks = 0